import {parseGid} from '@shopify/hydrogen-react';

/**
 * Parses a string or number into a number.
 * If id is a string, it is assumed to be a Shopify gid string like "gid://shopify/Product/1234567890".
 */
export default function parseId(id: string | number): number {
  if (typeof id === 'number') return id;
  if (id.startsWith('gid://')) return parseInt(parseGid(id).id);
  return parseInt(id);
}
